import { createRoutine } from 'redux-saga-routines';

export const showPositionProfileModalRoutine = createRoutine('SHOW_POSITION_PROFILE_MODAL');
export const showSurveyBuilderModalRoutine = createRoutine('SHOW_SURVEY_BUILDER_MODAL');
export const showRequestBuilderModalRoutine = createRoutine('SHOW_REQUEST_BUILDER_MODAL');
export const showContactProfileModalRoutine = createRoutine('SHOW_CONTACT_PROFILE_MODAL');
